import { productGridCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductGridCard";
import { COLORS } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(productGridCardStyles, {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding-bottom: 0;
            border: 1px solid #e1e7ed;
            border-radius: 10px 10px 10px 10px;
            position: relative;
            &:hover {
                border: 1px solid #316fb2;
            }
            div[class^="InventoryMessage"] {
                position: absolute;
                left: 12px;
            }
            button[data-test-selector^="actionsAddToList"] {
                position: absolute;
                top: 0.7rem;
                right: 1rem;
            }
            button[data-test-selector^="actionsAddToCart"] {
                border-radius: 0 0 0 8px;
            }
        `,
    },
    imageWrapper: {
        css: css`
            margin: inherit;
        `,
    },
});
